import { isObjectDeeplyChanged } from '../../../util/state';
import { OverlayContent } from '../../../enums/elementId';
import { State } from '../index';

export const getUpdateFlags = (state: State, oldState: State) => {
    const { form, loading, addresses, avcResult, isOverlayOpen, activeOverlay } = state;
    const updateForm = (form.index !== oldState.form.index) || !form.touched;
    const isValidAvcResult = avcResult && oldState.avcResult !== avcResult;
    const isOverlayOpened = isOverlayOpen && oldState.isOverlayOpen !== isOverlayOpen;
    const isAvcOpened = isOverlayOpened && activeOverlay === OverlayContent.FORM;

    return {
        form: updateForm || isAvcOpened,
        addressNotification: addresses.toString() !== oldState.addresses.toString(),
        button: isObjectDeeplyChanged(form, oldState.form),
        loading: oldState.loading !== loading,
        isValidAvcResult,
    };
};
